
import { Component, Vue } from "vue-property-decorator";
import DomainTableSetup from "./domain/DomainTableSetup.vue";
import DomainGroupMappingTable from "./domain-group/DomainGroupMappingTable.vue" 

@Component({
	components: {
        "domain-table-setup": DomainTableSetup,
        "domain-group-table": DomainGroupMappingTable
	}
})
export default class ActiveDirectorySetup extends Vue {
    
    private selectedDomainId: number = null;

    private onDomainSelected(domainId: number) {
		this.selectedDomainId = domainId;
	}
}
